<template>
    <VAppLayout :is-nav-visible="false">
        <VStatusScreen
            tone="info"
            :title="$t('notFound.title')"
            :message="$t('notFound.message')">
            <template #icon>
                <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
                    <path d="M20 20l-3.6-3.6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M9 9l4 4M13 9l-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </template>
            <template #actions>
                <VButton variant="primary" gradient size="lg" full-width v-on:click.native="handleBackClick">
                    {{ $t('notFound.back') }}
                </VButton>
            </template>
        </VStatusScreen>
    </VAppLayout>
</template>

<script>
import VAppLayout from "@/layouts/VAppLayout.vue";
import VStatusScreen from "@/components/ui/VStatusScreen.vue";
import VButton from "@/components/ui/VButton.vue";

export default {
    name: "NotFoundTab",
    components: { VAppLayout, VStatusScreen, VButton },
    computed: {
        companyName() {
            return this.$store.getters.getCompanyName;
        },
    },
    methods: {
        handleBackClick() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else if (this.companyName) {
                this.$router.push({ path: '/', query: { cn: this.companyName } });
            }
        },
    },
};
</script>
